import Scrolling from '../utils/class/scrolling';

const QUERY = '.site-preloader';
const DURATION = null;

/**
 * This feature is used to set preloader behavior
 * 
 * @class Preloader
 * @param {string} [query]
 * @param {number} [duration]
 * @param {function} [onload]
 */

export default class Preloader {
    constructor (query = QUERY, duration = DURATION, onload = () => {}) {    
        const el = document.querySelector(query) || document.querySelector(QUERY);
        if (!el) throw new Error('Preloader not found');

        this.el = el;
        this.duration = duration;
        this.onload = onload;
        this.scrolling = new Scrolling();

        return this.init();
    }

    init () {
        this.scrolling.disable();

        return new Promise((resolve) => {
            if (this.duration) {
                setTimeout(() => {
                    this.hide();
                    this.scrolling.enable();
                    this.onload();

                    resolve();
                }, this.duration);
            } else {
                window.addEventListener('load', () => {
                    this.hide();
                    this.scrolling.enable();
                    this.onload();
    
                    resolve();
                });
            }
        });
    }

    hide () {
        this.el.classList.add('hidden');
    }
}

/**
 * Usage example
 * 
 * import Preloader from 'components/preloader';
 * 
 * new Preloader('.site-preloader', null, () => {
 *  console.log('preloader loaded');
 * });
 * 
 * OR
 * 
 * new Preloader().then(() => console.log('preloader loaded'));
 * 
 */
